import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import TierRewardsContent from "modules/Tiers/Rewards";

import React from "react";
import { useParams } from "react-router";

import { setTitle } from "utilities/helper/setTitle";

const TierRewardsPage: React.FC = () => {
  setTitle("Tiering Reward");
  const { tierName } = useParams();

  return (
    <Auth>
      <Layout>
        <TierRewardsContent tierName={tierName} />
      </Layout>
    </Auth>
  );
};

export default TierRewardsPage;
